import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Education from './components/Education';
import Contact from './components/Contact';
import LanguageSelector from './components/LanguageSelector';
import PrintButton from './components/PrintButton';
import PrintHeader from './components/PrintHeader';
import PrintAbout from './components/PrintAbout';
import PrintExperience from './components/PrintExperience';
import PrintEducation from './components/PrintEducation';
import './App.css';
import profileData from './data/profileData.json';

function App() {
  const [language, setLanguage] = useState('en');
  const [data, setData] = useState(profileData[language]);

  useEffect(() => {
    setData(profileData[language]);
    document.body.setAttribute('data-lang', language);
  }, [language]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-stone-50 via-stone-100 to-stone-200">
      {/* Web View */}
      <div className="print:hidden">
        <Header language={language} data={data.personal} />
        <LanguageSelector language={language} setLanguage={setLanguage} />
        <PrintButton language={language} />
        <main className="pt-20">
          <Hero data={data.hero} personal={data.personal} />
          <About data={data.about} />
          <Experience data={data.experience} language={language} />
          <Education data={data.education} />
          <Contact data={data.contact} personal={data.personal} />
        </main>
      </div>

      {/* Print View */}
      <div className="hidden print:block">
        <PrintHeader personal={data.personal} />
        <PrintAbout data={data.about} />
        <PrintExperience data={data.experience} language={language} />
        <PrintEducation data={data.education} language={language} />
      </div>
    </div>
  );
}

export default App;